module.exports = {
          srcSet: __webpack_public_path__ + "1af86527926bb903ca56e21852c9256f-91.png"+" 91w",
          images:[ {path: __webpack_public_path__ + "1af86527926bb903ca56e21852c9256f-91.png",width: 91,height: 91}],
          src: __webpack_public_path__ + "1af86527926bb903ca56e21852c9256f-91.png",
          toString:function(){return __webpack_public_path__ + "1af86527926bb903ca56e21852c9256f-91.png"},
          
          width: 91,
          height: 91
        }